module.exports = __webpack_public_path__ + "static/assets/b5887853a5f97a43885e95a94c389b54.png";